import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getHandoffs = createAsyncThunk(
  "handoff/getHandoffs",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/handoffs/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const createHandoff = createAsyncThunk(
  "handoff/createHandoff",
  async ({ order_id, driver_id }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/handoffs/`,
        { order_id, driver_id },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getHandoffDetail = createAsyncThunk(
  "handoff/getHandoffDetail",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/handoffs/${id}/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const scanHandoffItem = createAsyncThunk(
  "handoff/scanHandoffItem",
  async ({ handoffId, sku, quantity }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/handoffs/${handoffId}/scan/`,
        { sku, quantity },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const confirmSubstitution = createAsyncThunk(
  "handoff/confirmSubstitution",
  async (
    { handoffId, handoff_item_id, substitute_sku, quantity, reason },
    { rejectWithValue }
  ) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/handoffs/${handoffId}/substitute/`,
        {
          handoff_item_id,
          substitute_sku,
          quantity,
          ...(reason?.trim() && { reason }),
        },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const completeHandoff = createAsyncThunk(
  "handoff/completeHandoff",
  async ({ handoffId, notes, force }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/handoffs/${handoffId}/complete/`,
        { ...(notes?.trim() && { notes }), force },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const deliverHandoff = createAsyncThunk(
  "handoff/deliverHandoff",
  async ({ handoffId, notes }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/handoffs/${handoffId}/deliver/`,
        { ...(notes?.trim() && { notes }) },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getHandoffSummary = createAsyncThunk(
  "handoff/getHandoffSummary",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/handoffs/${id}/summary/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
